import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  head: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: 14.5,
  },
  bodyTitle: { fontSize: 13, color: "gray" },
  alert: {
    fontSize: 12,
  },
  icon: {
    color: "gray",
    cursor:"pointer"
  },
}));

export default useStyles;
